import React from 'react';
import SyncedInfoLink from './SyncedInfoLink';

const TableauSyncInfo = ({ displayName = 'Workbench', embedUrl = '' }) => {
  return <SyncedInfoLink name={displayName} url={embedUrl} />;
};

export default TableauSyncInfo;
